import React from 'react'
import { Text, Container } from './index.style'
import LighterText from 'components/Text/Lighter'
import Input from 'components/Inputs/Interface'

interface TextAreaProps extends Input {
	disabled?: boolean
	value?: string
}
class TextArea extends React.Component<TextAreaProps> {
	render() {
		return (
			<Container>
				<LighterText>{this.props.title}</LighterText>
				<Text {...this.props} />
			</Container>
		)
	}
}

export default TextArea
